import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {MatDialog} from "@angular/material";
import {ServiceLog} from "../../../../../classes/serviceLog";
import {kanServiceLogDialog} from "../../../dialogs/service-log-dialog/component";
import {kanContractsService} from "../../../../services/services/contracts";
import {kanRemoveDialog} from "../../../../common/dialogs/remove-dialog/component";
import {kanServicesService} from "../../../../services/services/services";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-service-logs-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanServiceLogsListItem {
    @Input() log: ServiceLog;
    @Input() searchText: string;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor(private stateService: StateService,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private servicesService: kanServicesService,
                private contractsService: kanContractsService) {
    }

    ngOnInit(): void {
    }

    get role(): string {
        return this.authService.role;
    }

    public edit(event) {
        let dialogRef = this.dialog.open(kanServiceLogDialog, {
            data: {
                userId: this.log.userId,
                dogId: this.log.dogId,
                serviceLog: this.log
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'update') {
                    this.refresh.emit();
                }
            });
    }

    public showContract() {
        this.contractsService.showContract(this.log.service.contractId, this.log.userId, this.log.dogId);
    }

    public remove(event) {
        let dialogRef = this.dialog.open(kanRemoveDialog, {
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'remove') {
                this.servicesService.removeService(this.log)
                    .then((data) => {
                        this.refresh.emit();
                    });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service-logs/list-item/component.ts